/**
 * tariffs/registry.ts — State Tariff Registry
 * =============================================
 * Single source of truth for which tariff config to use per state.
 *
 * TO ADD A NEW STATE:
 *  1. Create  src/tariffs/<state-code>.ts  implementing StateTariff
 *  2. Add the StateCode to the union type in types.ts
 *  3. Import and register it here (one line each)
 *  4. Add SheetSource entries (with stateCode set) in your meter registry
 *  Done. No other files need to change.
 */

import type { StateCode, StateTariff } from './types';
import { WestBengalTariff }    from './west-bengal';
import { TelanganaTariff }     from './telangana';
// import { MadhyaPradeshTariff } from './madhya-pradesh';
// import { MaharashtraTariff } from './maharashtra';   ← uncomment when ready

// ─── Registry Map ────────────────────────────────────────────────────────────

const TARIFF_REGISTRY: Partial<Record<StateCode, StateTariff>> = {
  'west-bengal':    WestBengalTariff,
  'telangana':      TelanganaTariff,
  // 'madhya-pradesh': MadhyaPradeshTariff,
  // 'maharashtra': MaharashtraTariff,
};

// ─── Accessor ─────────────────────────────────────────────────────────────────

export function getTariff(stateCode: StateCode): StateTariff {
  const tariff = TARIFF_REGISTRY[stateCode];
  if (!tariff) {
    throw new Error(
      `[Cortex] No tariff registered for state "${stateCode}". ` +
      `Create src/tariffs/${stateCode}.ts and register it in src/tariffs/registry.ts.`,
    );
  }
  return tariff;
}

export function getAllTariffs(): StateTariff[] {
  return Object.values(TARIFF_REGISTRY) as StateTariff[];
}

export function isSupportedState(stateCode: string): stateCode is StateCode {
  return stateCode in TARIFF_REGISTRY;
}
